import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { MaterialService } from './services/material.service';
import { MaterialControllerService } from '@app/api';

@Component({
  selector: 'app-material',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet
  ],
  providers: [MaterialService, MaterialControllerService],
  template: `
    <router-outlet></router-outlet>
  `,
  styles: []
})
export class MaterialComponent {}
